export const fontStyle = {
  h1: `
    font-family: Ubuntu;
    font-weight: bold;
    line-height: 140%;
    letter-spacing: 0.02em;
    font-size: 48px;

    @media only screen and (min-width: 960px) {
      font-size: 72px;
      line-height: normal;
      letter-spacing: normal;
    }
  `,
  h2: `
    font-family: Ubuntu;
    font-weight: bold;
    font-size: 40px;
    line-height: normal;

    @media only screen and (min-width: 960px) {
      font-size: 60px;
    }
  `,
  h3: `
    font-family: Ubuntu;
    font-weight: bold;
    font-size: 32px;
    line-height: 120%;
    letter-spacing: 0.02em;

    @media only screen and (min-width: 960px) {
      font-size: 48px;
      line-height: 140%;
    }
  `,
  subhead1Regular: `
    font-family: Ubuntu;
    font-weight: normal;
    font-size: 24px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      font-size: 32px;
    }
  `,
  subhead1Medium: `
    font-family: Ubuntu;
    font-weight: 500;
    font-size: 24px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      font-size: 32px;
    }
  `,
  subhead1Bold: `
    font-family: Ubuntu;
    font-weight: bold;
    font-size: 24px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      font-size: 32px;
    }
  `,
  subhead2Regular: `
    font-family: Ubuntu;
    font-weight: normal;
    font-size: 22px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      font-size: 24px;
    }
  `,
  subhead2Medium: `
    font-family: Ubuntu;
    font-weight: 500;
    font-size: 22px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      font-size: 24px;
    }
  `,
  subhead2Bold: `
    font-family: Ubuntu;
    font-weight: bold;
    font-size: 22px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      font-size: 24px;
    }
  `,
  subhead3Regular: `
    font-family: Ubuntu;
    font-weight: normal;
    font-size: 18px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      font-size: 20px;
    }
  `,
  subhead3Bold: `
    font-family: Ubuntu;
    font-weight: bold;
    font-size: 18px;

    @media only screen and (min-width: 960px) {
      font-size: 20px;
    }
  `,
  bodyText: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: normal;
    font-size: 20px;
    line-height: 140%;
  `,
  blogBodyText: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: normal;
    font-size: 20px;
    line-height: 140%;

    @media only screen and (min-width: 960px) {
      line-height: 180%;
    }
  `,
  buttonText1: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: 500;
    font-size: 20px;
  `,
  buttonText2: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.02em;

    @media only screen and (min-width: 960px) {
      font-size: 18px;
    }
  `,
  title1Regular: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.02em;
  `,
  title1Medium: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.02em;
  `,
  title1Bold: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.02em;
  `,
  title2Regular: `
    font-family: Ubuntu;
    font-weight: normal;
    font-size: 8px;

    @media only screen and (min-width: 960px) {
      font-size: 14px;
    }
  `,
  tags1: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.02em;
  `,
  tags1Medium: `
    font-family: 'Maven Pro', sans-serif;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.02em;
  `,
  tags2: `
    font-family: Ubuntu;
    font-weight: bold;
    font-size: 14px;
  `,
  tags3: `
  font-family: Maven Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
`,
};
